import {B2BCheckoutContextState} from '../types';
import {DefaultContext} from '../../utils/types';
import React from 'react';

export const initialState: B2BCheckoutContextState = {
  ordersForValidation: [],
  ordersForUpdation: [],
};

const defaultVal: DefaultContext<B2BCheckoutContextState> = {
  state: initialState,
  dispatch: null,
};

export const B2BCheckoutContext = React.createContext(defaultVal);
